<template>
  <div class="flex-col add-Info">
    <div class="flex-col content-info">
      <form action="">
        <div class="flex-col">

          <!-- 机构 -->
          <div class="flex-row type-row"
            v-show="!isUserIndustry">
            <div class="flex-row type-left">
              <label class="must-label">{{ $t('PEOrganizationName') }}</label> <i class="must-input">* </i>
            </div>
            <div class="flex-col red-bg"
              style="padding: 0 1rem;">
              <input class="input-style"
                type="text"
                ref="org"
                v-model="org.name"
                autocomplete="off"
                @blur="onBlur('org')"
                @keyup="getMyDeBounce($event,'org')"
                @change="selectChange($event,'org')"
                :placeholder="$t('PEOrganizationNameTips')">
              <select-panel v-show="org.show"
                :component-name="org.componentName"
                :loading="org.loading"
                :data-list="org.showList"
                @itemClick="selectItem"></select-panel>
            </div>
          </div>
          <!-- @click="getFilterList($event,'org')" -->
          <!-- 用户 -->
          <div class="flex-row type-row"
            v-show="!isUserIndustry">
            <div class="flex-row type-left">
              <label class="must-label">{{ $t('peContactName') }} </label> <i class="must-input">* </i>
            </div>
            <div class="flex-col"
              style="padding: 0 1rem;">
              <input class="input-style"
                type="text"
                ref="user"
                :readonly="user.disable"
                v-model="user.name"
                autocomplete="off"
                @click="getFilterList($event,'user')"
                @blur="onBlur('user')"
                @keyup="getMyDeBounce($event,'user')"
                @change="selectChange($event,'user')"
                :placeholder="$t('peContactNameTips')">
              <select-panel v-show="user.show"
                :component-name="user.componentName"
                :loading="user.loading"
                :data-list="user.showList"
                @itemClick="selectItem"></select-panel>
            </div>
          </div>

          <!-- 关系深度 -->
          <div class="flex-row type-row"
            v-show="!isUserIndustry">
            <div class="flex-row type-left">
              <label class="must-label">{{ $t('RelationDeepth') }}</label> <i class="must-input">* </i>
            </div>
            <div class="flex-col"
              style="padding: 0 1rem;">
              <input class="input-style"
                ref="relationDeepth"
                type="text"
                readonly
                v-model="relationDeepth.name"
                autocomplete="off"
                @click="getFilterList($event,'relationDeepth')"
                @blur="onBlur('relationDeepth')"
                @keyup="getFilterList($event,'relationDeepth')"
                @change="selectChange($event,'relationDeepth')"
                :placeholder="$t('RelationDeepthTips')">

              <select-panel v-show="relationDeepth.show"
                :component-name="relationDeepth.componentName"
                :loading="relationDeepth.loading"
                :data-list="relationDeepth.showList"
                @itemClick="selectItem"></select-panel>
            </div>
          </div>

          <!-- 职务 -->
          <div class="flex-row type-row"
            v-show="!isUserIndustry">
            <div class="flex-row type-left">
              <label class="must-label">{{ $t('Position') }}</label> <i class="must-input">* </i>
            </div>
            <div class="flex-col"
              style="padding: 0 1rem;">
              <input class="input-style"
                ref="position"
                type="text"
                v-model="user.position"
                autocomplete="off"
                @click="getFilterList($event,'position')"
                @blur="onBlur('position')"
                @keyup="getFilterList($event,'position')"
                @change="selectChange($event,'position')"
                :placeholder="$t('PositionSelectTips')">

              <select-panel v-show="positionSel.show"
                :component-name="positionSel.componentName"
                :loading="positionSel.loading"
                :data-list="positionSel.showList"
                @itemClick="selectItem"></select-panel>
            </div>
          </div>

          <!-- 专注行业 -->
          <!-- @focus.prevent="showInput" -->
          <div class="flex-row type-row">
            <div class="flex-row type-left">
              <label class="must-label">{{ $t('专注行业') }}</label>
            </div>
            <div class="flex-col"
              style="padding: 0 1rem;">
              <multiselect placeholder="请选择"
                v-model="userIndustry.selected"
                :multiple="true"
                :close-on-select="false"
                selectLabel="请选择"
                selectedLabel="已选择"
                deselectLabel="取消选择"
                :maxHeight=200
                :searchable="true"
                ref="userIndustryControl"
                :style="{'--color':selectColor}"
                :options="userIndustry.showList"
                @open="industryOpen"
                @close="closeIndustry">
              </multiselect>
            </div>
          </div>

          <!-- 备注 -->
          <div class="flex-row type-row">
            <div class="flex-row type-left">
              <label>{{ $t('remark') }}</label>
            </div>
            <div class="flex-col"
              style="padding: 0 1rem;">
              <input class="input-style"
                type="text"
                ref="remark"
                v-bind:readonly="remarkDisable"
                v-model="remark"
                autocomplete="off"
                :placeholder="$t('remarkTips')">
            </div>
          </div>

        </div>
      </form>
      <div class="submit-button">
        <van-button round
          block
          type="info"
          native-type="submit"
          @click="onSubmit">
          {{ $t('common.commitTip') }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import webService from "@/network/webService";
import _ from "lodash";
import commonjs from "@/common/common";
import userInfo from "@/common/loginInfo";
import { Toast } from "vant";
import SelectPanel from "@/components/common/SelectPanel";
import Multiselect from 'vue-multiselect';

var orgDe, userDe;
export default {
  name: "orgRelationship",
  components: {
    Toast,
    SelectPanel,
    Multiselect
  },
  props: {
    url: {
      type: String
    }
  },
  data () {
    return {
      fromUrl: '',
      isEdit: false,
      isShowBack: false,
      id: null,
      categoryList: [],
      responsibilityList: [],
      deepList: [],
      userList: [],
      oldPosition: "",
      positionDisable: true,
      remarkDisable: false,
      org: {
        name: "",
        showList: [],
        item: {},
        disable: false,
        show: false,
        loading: false,
        componentName: "org",
      },
      user: {
        name: "",
        showList: [],
        item: {},
        disable: false,
        show: false,
        loading: false,
        componentName: "user",
        position: "",
      },
      responsibility: {
        name: "",
        showList: [],
        item: {},
        disable: false,
        show: false,
      },
      relationDeepth: {
        name: "",
        showList: [],
        item: {},
        disable: false,
        show: false,
        loading: false,
        componentName: "relationDeepth",
      },
      positionSel: {
        name: "",
        showList: [],
        item: {},
        disable: false,
        show: false,
        loading: false,
        componentName: "position",
      },
      userIndustry: {
        selected: null,
        showList: [],
      },
      selectColor: '#adadad',
      isUserIndustry: false,
      remark: "",
    };
  },
  watch: {
    "user.name": {
      handler: function () {
        if (this.isEdit) return;
        //新增时特殊处理，人工添加新联系人
        console.log("user.name", this.user);
        var newName = _.trim(this.user.name);
        if (this.user.item == null || this.user.item.name != newName) {
          var find = _.find(this.user.showList, ["name", newName]);
          if (find) {
            this.user.item = find;
            this.user.position = find.position;
            if (commonjs.isEmpty(find.position)) {
              this.positionDisable = false;
            } else {
              this.positionDisable = true;
            }
          } else {
            this.user.item = null;
            this.user.position = "";
            this.positionDisable = false;
          }
        }
      },
    },
  },
  created () {
    var id = this.$route.params.id;
    var contactId = this.$route.query.id;
    var orgData = this.$route.query.orgData;
    //是否从编辑页面过来
    var relationshipId = this.$route.query.relationshipId;
    //从机构公司页面过来
    if (orgData) {
      console.log(orgData);
      this.isShowBack = true;
      this.org.name = orgData.name;
      this.org.item = orgData;
      this.org.nameEn = "";
    }
    if (contactId) {
      //  那么需要锁定联系人
      this.isEdit = true;
      this.isShowBack = true;
      webService.getContactDetails(contactId).then((res) => {
        this.org.name = res.data.peorganizationName;
        this.org.nameEn = "";
        this.org.item.name = res.data.peorganizationName;
        this.org.item.id = res.data.peorganizationId;
        this.oldPeorganizationId = res.data.peorganizationId;
        this.user.name = res.data.name;
        this.user.nameEn = "";
        this.user.item.name = res.data.name;
        this.user.item.id = res.data.id;
        this.user.position = res.data.position;
        this.oldPosition = res.data.position;
        this.responsibility.name = res.data.responsibilityName;
        this.responsibility.item.id = res.data.responsibilityId;
        this.remark = "";
        //只能编辑关系深度 
        //需求更改，都能编辑
        // this.org.disable = true;
        this.user.disable = true;
        // this.responsibility.disable = true;
        // this.positionDisable = true;
        this.remarkDisable = false;
      });
    }
    if (relationshipId) {
      this.isEdit = true;
      this.isShowBack = true;
      var param = [relationshipId];
      webService.getRelationshipsByIds(param).then((res) => {
        var data = res.data[0];
        this.id = data.id;
        this.org.name = data.peOrganizationName;
        this.org.nameEn = "";
        this.org.item.name = data.peOrganizationName;
        this.org.item.id = data.peOrganizationId;
        this.user.name = data.peContactName;
        this.user.nameEn = "";
        this.user.item.name = data.peContactName;
        this.user.item.id = data.peContactId;
        this.user.position = data.position;
        this.oldPosition = data.position;
        this.responsibility.name = data.responsibility;
        this.responsibility.item.id = data.responsibilityId;
        this.relationDeepth.item.id = data.relationDeepthId;
        this.relationDeepth.name = data.relationDeepth;
        this.remark = _.trim(data.remark);
        //专注行业 
        this.userIndustry.selected = _.split(data.userIndustry, ',').filter(str => { return !!str });
        this.user.disable = true;
        this.remarkDisable = false;
        if (data.orgPassed && data.userPassed) {
          //   this.org.disable = true;
          //   this.responsibility.disable = true;
          //   this.positionDisable = true;
        } else if (data.orgPassed && !data.userPassed) {
          //   this.org.disable = true;
        }
      });
    }
    this.onInitData();
    orgDe = _.debounce(this.getMyOrgList, 100);
    userDe = _.debounce(this.getUserList, 100);

  },
  methods: {
    onInitData: function () {
      this.getCommonInfo();
    },
    getCommonInfo () {
      var param = [
        commonjs.commonInfoEnmus.Responsibility,
        commonjs.commonInfoEnmus.Title,
        commonjs.commonInfoEnmus.RelationDeepth,
        commonjs.commonInfoEnmus.userIndustry,
      ];
      webService.getCommonInfo(param).then((res) => {
        this.categoryList = res.data;
        this.responsibilityList = _.filter(
          this.categoryList,
          function (m) {
            return (
              m.category ==
              commonjs.commonInfoEnmus.Responsibility
            );
          }
        );
        this.deepList = _.filter(this.categoryList, function (m) {
          return (
            m.category == commonjs.commonInfoEnmus.RelationDeepth
          );
        });
        this.positionSel.showList = _.filter(
          this.categoryList,
          function (m) {
            return m.category == commonjs.commonInfoEnmus.Title;
          }
        );
        this.userIndustry.showList = _.filter(this.categoryList, function (m) {
          return (
            m.category == commonjs.commonInfoEnmus.userIndustry
          );
        });
        this.userIndustry.showList = _.orderBy(
          this.userIndustry.showList,
          ["sort"],
          ["asc"]
        );
        this.userIndustry.showList = _.map(this.userIndustry.showList, 'name');
      });
    },
    onSubmit: function () {
      if (this.valudateBeforeSubmit()) {
        if (this.org.item) {
          if (
            (this.org.item.name &&
              this.org.item.name !== this.org.name) ||
            !this.org.item.name
          ) {
            this.org.item = null;
            this.org.show = false;
          }
        }
        var addInfo = {
          PEOrganizationName: this.org.name,
          PEOrganizationId:
            this.org.item != null && this.org.item.id
              ? this.org.item.id
              : "",
          OldPeorganizationId: this.oldPeorganizationId,
          PEContactName: this.user.name,
          PEContactId:
            this.user.item != null && this.user.item.id
              ? this.user.item.id
              : "",
          Position: this.user.position,
          ResponsibilityName: this.responsibility.name,
          ResponsibilityId:
            this.responsibility.item != null &&
              this.responsibility.item.id
              ? this.responsibility.item.id
              : null,
          RelationDeepthId:
            this.relationDeepth.item != null &&
              this.relationDeepth.item.id
              ? this.relationDeepth.item.id
              : null,
          UserId: userInfo.userToken.userId,
          UserProfileName: userInfo.userToken.userName,
          IsEdit: this.isEdit,
          ID: this.id,
          remark: _.trim(this.remark),
        };
        if (this.oldPosition != this.user.position) {
          //更改了职务
          addInfo.ManualPosition = this.user.position;
        }
        //专注行业  
        addInfo.UserIndustry = this.userIndustry.selected;
        webService.addRelationship(addInfo).then((res) => {
          if (res.data.result) {
            if (this.$route.query.id ||
              this.$route.query.orgData ||
              this.$route.query.relationshipId
            ) {
              if (this.$route.query.orgId) {
                this.$bus.$emit("busfreshOrg", { orgId: this.$route.query.orgId });
              } else if (this.$route.query.id) {
                this.$bus.$emit("busfreshContact", { id: this.$route.query.id });
                this.$bus.$emit("busfreshPwC");
              }
              Toast.success(res.data.resultMsg);
              let _this = this;
              setTimeout(() => {
                // this.$router.go(-1);
                if (_this.url && _this.url.indexOf('myFavorites/') > -1) {
                  // console.log(_this.url);
                  _this.$router.push({
                    path: "/myFavorites/" + Math.random() * 1000000,
                  });
                } else {
                  _this.$router.go(-1);
                }
              }, 800);
            } else {

              this.$router.push({
                path: "/home/addSuccess",
                query: {
                  isEdit: this.isEdit,
                  Passed: res.data.returnCode,
                },
              });
            }
          } else {
            Toast.fail(res.data.resultMsg);
          }
        });
      }
    },
    valudateBeforeSubmit () {
      var isOk = true;
      if (_.trim(this.org.name) == "") {
        this.org.name = "";
        this.$refs.org.setAttribute("class", "input-style change");
        isOk = false;
      }
      if (_.trim(this.user.name) == "") {
        this.user.name = "";
        this.$refs.user.setAttribute("class", "input-style change");
        isOk = false;
      }
      if (_.trim(this.relationDeepth.name) == "") {
        this.$refs.relationDeepth.setAttribute(
          "class",
          "input-style change"
        );
        isOk = false;
      }
      if (_.trim(this.user.position) == ""
        //&& !this.positionDisable
      ) {
        this.$refs.position.setAttribute("class", "input-style change");
        isOk = false;
      }
      if (_.trim(this.user.position) == "其他") {
        if (_.trim(this.remark) == "") {
          this.$refs.remark.setAttribute(
            "class",
            "input-style change"
          );
          isOk = false;
        }
      } else {
        this.$refs.remark.setAttribute(
          "class",
          "input-style"
        );
      }
      //专注行业
      // if (this.userIndustry.selected == null || this.userIndustry.selected.length == 0) {
      //   this.selectColor = '#c52a1a';
      //   isOk = false;
      // }
      return isOk;
    },
    goBack () {
      this.$router.go(-1);
    },
    getMyDeBounce (ev, type, operType) {
      if (type == "org") {
        orgDe(ev, operType);
      }
      if (type == "user") {
        userDe(ev);
      }
    },
    getFilterList (ev, type, operType) {
      if (type == "org") {
        //根据选中的机构过滤用户
        if (!this.org.disable) {
          this.org.show = this.org.name != '';
          this.getMyDeBounce(ev, type)
        }
      } else if (type == "user" && !this.isEdit) {
        //根据选中的机构过滤用户
        if (this.org.item != null && this.org.item.apiID) {
          this.user.loading = true;
          webService
            .getContactList(this.org.item.apiID, "")
            .then((res) => {
              this.user.loading = false;
              this.userList = res.data;
              this.user.showList = this.userList;
              this.user.show = this.user.showList.length > 0;
            });
        } else {
          this.user.showList = [];
        }
      } else if (type == "responsibility") {
        this.responsibility.showList = _.sortBy(
          this.responsibilityList,
          ["sort"]
        );
        this.responsibility.show = true;
      } else if (type == "relationDeepth") {
        this.relationDeepth.showList = _.sortBy(this.deepList, [
          "sort",
        ]);
        this.relationDeepth.show = true;
      } else if (type == "position") {
        this.positionSel.showList = _.sortBy(
          this.positionSel.showList,
          ["sort"]
        );
        this.positionSel.show = true;
      }
    },
    getMyOrgList (ev, operType) {

      console.log("getMyOrgList");

      if (this.org.disable) return;

      if (ev.keyCode == 38 || ev.keyCode == 40) {
        return false;
      }

      this.org.loading = true;
      webService
        .getOrganizationsByName(this.org.name)
        .then((res) => {
          this.org.loading = false;
          var index = 0;
          res.data.forEach(element => {
            index++;
            element.index = index;
          });
          this.org.showList = res.data;
          console.log(this.org.showList);
          this.org.show = this.org.showList.length > 0;
        });
      if (!this.isEdit) {
        this.user.showList = [];
        this.user.item = null;
        this.user.name = "";
        this.user.nameEn = "";
      }
    },
    selectChange (ev, type, operType) {
      setTimeout(() => {
        if (type == "org") {
          console.log(this.org.item);
          //如果已经选中的item与实际输入的名称不匹配，表示新加没有的选项
          //   if (this.org.item) {
          //     if (
          //       (this.org.item.name &&
          //         this.org.item.name !== this.org.name) ||
          //       !this.org.item.name
          //     ) {
          //       //Toast.fail('请选择系统中存在的机构');
          //       this.org.item = null;
          //       this.org.show = false;
          //     }
          //   }
          if (type == "user") {
            console.log("selectChange --user:" + ev);
            //如果已经选中的item与实际输入的名称不匹配，表示新加没有的选项
            if (this.user.item) {
              if (
                (this.user.item.name &&
                  this.user.item.name !== this.user.name) ||
                !this.user.item.name
              ) {
                this.user.item = null;
                this.user.show = false;
              }
            }
          }
          if (type == "responsibility") {
            //如果已经选中的item与实际输入的名称不匹配，表示新加没有的选项
            if (
              this.responsibility &&
              this.responsibility.item.name &&
              this.responsibility.item.name !==
              this.responsibility.name
            ) {
              this.responsibility.item = null;
              this.responsibility.show = false;
            }
          }
        }
      }, 100);
    },
    getUserList (ev, operType) {
      console.log("getUserList", this.org);

      if (this.user.disable) return;

      if (ev.keyCode == 38 || ev.keyCode == 40) {
        return false;
      }
      //先必须选择机构
      if (this.org.item != null && this.org.item.apiID) {
        this.user.loading = true;
        webService
          .getContactList(
            this.org.item.apiID,
            this.user.name,
            97020
          )
          .then((res) => {
            this.user.loading = false;
            this.user.showList = res.data;
            this.user.show = this.user.showList.length > 0;
          });
      }
    },
    selectItem (item, type, operType) {
      console.log("selectItem");
      if (type == "org") {
        if (item) {
          this.org.item = item;
          this.org.show = false;
          if (operType == "en") {
            this.org.nameEn = item.name;
            this.org.name = "";
          } else {
            this.org.name = item.name;
            this.org.nameEn = "";
          }
        }
      }
      if (type == "responsibility") {
        if (item) {
          this.responsibility.item = item;
          this.responsibility.name = item.name;
          this.responsibility.show = false;
        }
      }
      if (type == "relationDeepth") {
        if (item) {
          this.relationDeepth.item = item;
          this.relationDeepth.name = item.name;
          this.relationDeepth.show = false;
        }
      }
      if (type == "user") {
        if (item) {
          this.user.item = item;
          this.user.show = false;
          this.user.position = item.position;
          this.oldPosition = item.position;
          this.positionDisable = true;
          if (operType == "en") {
            this.user.nameEn = item.name;
            this.user.name = "";
          } else {
            this.user.name = item.name;
            this.user.nameEn = "";
          }
          if (this.user.item.responsibilityId) {
            var resInfo = _.find(this.responsibilityList, [
              "id",
              this.user.item.responsibilityId,
            ]);
            this.responsibility.item = resInfo;
            this.responsibility.name =
              resInfo == null ? "" : resInfo.name;
          } else {
            this.responsibility.item = null;
            this.responsibility.name = "";
          }
        }
      }
      if (type == "position") {
        if (item) {
          this.positionSel.item = item;
          this.positionSel.name = item.name;
          this.positionSel.show = false;
          this.user.position = item.name;
        }
      }
    },
    onBlur (type) {
      console.log("onBlur");
      setTimeout(() => {
        //选择了机构后，用户需要重新选择
        if (type == "org") {
          this.org.showList = [];
          this.org.show = false;
        }
        if (type == "responsibility") {
          this.responsibility.show = false;
        }
        if (type == "user") {
          this.user.show = false;
        }
        if (type == "relationDeepth") {
          this.relationDeepth.show = false;
        }
        if (type == "position") {
          this.positionSel.show = false;
        }
      }, 100);
    },
    gosuccess () {
      this.$router.push({
        path: "/home/addSuccess",
      });
    },
    showInput () {
      this.$refs.userIndustryControl.setAttribute('readonly', 'readonly');
    },
    industryOpen () {
      var x = document.getElementsByClassName("multiselect__input")[0];
      console.log(x);
      x.readOnly = "readonly";
      this.isUserIndustry = true;
    },
    //展开事件
    closeIndustry (value, id) {
      this.isUserIndustry = false;
    }
  },
  beforeRouteEnter (to, from, next) {
    console.log('beforeRouteEnter');
  }
};
</script>
  
<style lang="scss" scoped>
@import "../../../styles/theme.scss";
.top-title {
  font-family: "PingFangSC-Medium";
  font-size: 26px;
  color: #2d2d2d;
  text-align: center;
  line-height: 36px;
}
.left-icon {
  font-size: 24px;
  padding-left: 1rem;
  color: darkgray;
  line-height: 66px;
}
.change::-webkit-input-placeholder {
  color: #c52a1a;
}
.input-style {
  font-weight: bold;
  border: none;
  border-bottom: 1px solid #dedede;
}
/deep/ .van-field__value {
  border: none;
  border-bottom: 1px solid #dedede;
  //  ::-webkit-input-placeholder {
  //     color: red;
  // }
}
.add-Info {
  height: calc(100% - 50px);
}
.title-right {
  flex: 1;
  text-align: right;
  padding: 1rem;
  font-family: "PingFangSC-Regular";
  font-size: 14px;
}
.content-info {
  height: 100%;
  justify-content: space-between;
}
.type-row {
  font-size: 14px;
  line-height: 24px;
  display: flex;
  flex-direction: column;
}
.user-select {
  position: absolute;
  z-index: 100; //border: 2px solid #f5f2f2e0;
  width: 95%;
  margin-top: 27px;
  max-height: 100px;
  overflow: auto;
}
.down-list {
  padding: 12px;
  margin-right: 12px;
  background-color: #f3f2f2;
}

input:read-only {
  background: #fff;
  color: #2d2d2d;
}
input::-webkit-input-placeholder {
  font-size: 14px;
  color: #bebebe;
}
input:-ms-input-placeholder {
  font-size: 14px;
  color: #bebebe;
}
.type-left {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  flex: none;
  box-sizing: border-box;
  width: 24rem;
  color: #2d2d2d;
  text-align: left;
  padding-left: 16px;
  padding-top: 10px;
  font-family: "PingFangSC-Regular";
  font-size: 12px;
}
.type-right {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  color: #969799;
  text-align: right;
  margin-left: 12px;
}
.must-label {
  margin-right: 10px;
}
.must-input {
  margin-left: -8px;
  color: #c52a1a;
  font-size: 14px;
  margin-top: 2px;
}
.submit-button {
  margin: 20px;
}
/deep/ .van-cell {
  display: flex;
  flex-direction: column;
}
/deep/ .van-button--round {
  border-radius: 1px;
}
/deep/ .van-button--info {
  background-color: #c52a1a;
  border: 1px solid #c52a1a;
}
/deep/ .multiselect__tags {
  max-height: 100px;
  overflow: auto;
}
/deep/ .multiselect__tag {
  background: #edeaea;
  color: black;
  font-weight: bold;
}
/deep/ .multiselect__option--highlight {
  background: #c52a1a;
}
/deep/ .multiselect__option--highlight:after {
  background: #ff6a6a;
}
/deep/ .multiselect__tag-icon:hover {
  background: #777a79;
}
/deep/ .multiselect__placeholder {
  //color: #c52a1a;
  font-weight: bold;
  color: var(--color) !important;
}
/deep/ .multiselect__content-wrapper {
  position: initial !important;
}
/deep/ .multiselect__option {
  font-size: 14px;
  min-height: 30px;
  line-height: 10px;
}
/deep/ .multiselect__option:after {
  line-height: 34px;
}
</style>


// WEBPACK FOOTER //
// src/views/add/AddRelationship/orgRelationship.vue